import React, { setState } from 'react';
import { Formik, Form, Field, ErrorMessage, withFormik } from 'formik';
import { Effect } from 'formik-effect';
import Component from '@reach/component-component';
import * as yup from 'yup'; // Form Debugger
// import { Debug } from "./Debug";

import { Row, Col, Button } from 'react-bootstrap'; // Global Element

import { FormInput, FormCheckbox, Requirements } from './elements'; // Validation schema

import { validation, required } from './util/validation'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
var formikEnhancer = withFormik({
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      emailAddress: props.emailAddress,
      password: props.password,
      remember: props.remember
    };
  },
  validationSchema: yup.object().shape({
    emailAddress: validation.emailAddress,
    password: required('Password is required.') // TODO: Change to a constant

  }),
  handleSubmit: function handleSubmit(values, _ref) {
    var setSubmitting = _ref.setSubmitting;
    setTimeout(function () {
      alert(JSON.stringify(values, null, 2));
      setSubmitting(false);
    }, 1000);
  },
  displayName: "LoginForm" // helps with React DevTools

});

var LoginForm = function LoginForm(props) {
  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset;

  var signInClick = function signInClick() {
    var data = {
      gtm: {
        uniqueEventId: '8',
        elementId: "loginform-signin"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    type: "email",
    name: "emailAddress",
    label: "Email Address",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    type: "password",
    name: "password",
    label: "Password",
    component: FormInput
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    type: "checkbox",
    name: "remember",
    label: "Remember me",
    component: FormCheckbox
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    disabled: isSubmitting,
    id: "loginform-signin",
    onClick: signInClick,
    className: "cb-button-primary w-100"
  }, "Sign in"))));
};

export default formikEnhancer(LoginForm);